import { render, staticRenderFns } from "./OnlCgreportQueryFormItem.vue?vue&type=template&id=06d32827&scoped=true&"
import script from "./OnlCgreportQueryFormItem.vue?vue&type=script&lang=js&"
export * from "./OnlCgreportQueryFormItem.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgreportQueryFormItem.vue?vue&type=style&index=0&id=06d32827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d32827",
  null
  
)

export default component.exports